import { useState } from "react";

const STARS = [1, 2, 3, 4, 5] as const;

/** Label kualitas untuk tiap nilai bintang. */
export const RATING_LABELS: Record<number, string> = {
  1: "Sangat kurang",
  2: "Kurang",
  3: "Cukup",
  4: "Baik",
  5: "Sangat baik",
};

/** Tampilan bintang read-only (untuk daftar & ringkasan). */
export function StarDisplay({ rating, label }: { rating: number; label?: string }) {
  return (
    <span className="star-display" aria-label={`Penilaian ${rating} dari 5 bintang`}>
      {STARS.map((star) => (
        <span key={star} className={star <= rating ? "on" : ""} aria-hidden>
          ★
        </span>
      ))}
      {label ? <span className="star-display-label">{label}</span> : null}
    </span>
  );
}

/**
 * Pemilih bintang 1–5 (aksesibel: role radiogroup + tombol radio).
 * Mendukung papan ketik (Tab untuk berpindah, ←/→ untuk mengubah nilai).
 */
export function StarRating({
  value,
  onChange,
  disabled = false,
}: {
  value: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}) {
  const [hover, setHover] = useState<number | null>(null);
  const shown = hover ?? value;

  return (
    <div
      className="star-row"
      role="radiogroup"
      aria-label="Bintang penilaian layanan"
      onMouseLeave={() => setHover(null)}
    >
      {STARS.map((star) => (
        <button
          key={star}
          type="button"
          role="radio"
          aria-checked={value === star}
          aria-label={`${star} bintang — ${RATING_LABELS[star]}`}
          title={RATING_LABELS[star]}
          className={`star-btn ${star <= shown ? "on" : ""}`}
          disabled={disabled}
          onClick={() => onChange(star)}
          onMouseEnter={() => setHover(star)}
          onFocus={() => setHover(star)}
          onBlur={() => setHover(null)}
          onKeyDown={(event) => {
            if (event.key === "ArrowRight") {
              event.preventDefault();
              onChange(Math.min(5, value + 1));
            }
            if (event.key === "ArrowLeft") {
              event.preventDefault();
              onChange(Math.max(1, value - 1));
            }
          }}
        >
          ★
        </button>
      ))}
      <span className="star-label">
        {shown > 0 ? `${shown} — ${RATING_LABELS[shown]}` : "Pilih 1–5 bintang"}
      </span>
    </div>
  );
}
